export default "__VITE_ASSET__aRHTsido__"